import { useEffect, useRef, useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const POLL_INTERVAL = 30 * 60 * 1000;
const BUILD_HASH = typeof __APP_BUILD_HASH__ !== 'undefined' ? __APP_BUILD_HASH__ : null;

function hardReload(forceReloadToken) {
  if (forceReloadToken) {
    sessionStorage.setItem('force_reload_dismissed', String(forceReloadToken));
  }
  const url = new URL(window.location.href);
  url.searchParams.set('_v', Date.now());
  if ('caches' in window) {
    caches.keys()
      .then((names) => Promise.all(names.map((n) => caches.delete(n))))
      .finally(() => { window.location.replace(url.toString()); });
  } else {
    window.location.replace(url.toString());
  }
}

export default function VersionChecker() {
  const [outdated, setOutdated] = useState(false);
  const timerRef = useRef(null);
  const forceReloadTokenRef = useRef(null);

  const check = useCallback(async () => {
    if (!BUILD_HASH || BUILD_HASH === 'dev') return;
    try {
      const res = await fetch('/version.json?_=' + Date.now(), { cache: 'no-store' });
      if (!res.ok) return;
      const data = await res.json();
      if (data.hash && data.hash !== BUILD_HASH) {
        setOutdated(true);
      }

      if (data.forceReload) {
        forceReloadTokenRef.current = String(data.forceReload);
        const dismissed = sessionStorage.getItem('force_reload_dismissed');
        if (dismissed !== forceReloadTokenRef.current) {
          setOutdated(true);
        }
      }
    } catch (_) {}
  }, []);

  useEffect(() => {
    const delay = setTimeout(check, 5_000);
    timerRef.current = setInterval(check, POLL_INTERVAL);
    return () => {
      clearTimeout(delay);
      clearInterval(timerRef.current);
    };
  }, [check]);

  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === 'visible') check();
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, [check]);

  if (!outdated) return null;

  return (
    <Dialog open maxWidth="xs" fullWidth disableEscapeKeyDown>
      <DialogTitle>Доступно обновление</DialogTitle>
      <DialogContent>
        <Typography>
          Вышла новая версия приложения. Для корректной работы необходимо обновить страницу.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => hardReload(forceReloadTokenRef.current)} variant="contained">
          Обновить
        </Button>
      </DialogActions>
    </Dialog>
  );
}
